import { firstLetterToUppercase } from './stringUtilities.js';
import formatDate, {formatISODate} from './date/formatDate.js';
const arrays = ['procedureOfInterest'];

const formatToDoubleDigitDayMonth = (dayOrMonth) => (dayOrMonth.length === 2 ? dayOrMonth : `0${dayOrMonth}`);

const cleanDate = (dob = '') => {
  const slashCount = (dob.match(new RegExp('/', 'g')) || []).length;
  const dashCount = (dob.match(new RegExp('-', 'g')) || []).length;
  const isoFormatted = formatISODate(dob);

  if(dob !== isoFormatted) {
    return isoFormatted;
  }

  if (slashCount === 1 || dashCount === 1) {
    return formatDate(dob);
  }

  if (!dob.includes('-') && !dob.includes('/') && dob.length !== 8) {
    return dob;
  }
  if (!dob.includes('-') && !dob.includes('/') && dob.length === 8) {
    return formatDate(dob);
  }
  const parts = String(dob).split(dob.includes('-') ? '-' : '/');
  return `${formatToDoubleDigitDayMonth(parts[0])}/${formatToDoubleDigitDayMonth(parts[1])}/${parts[2]}`;
};

const fieldMap = {
  procedureOfInterest: ['procedure', 'procedures', 'procedureofinterest', 'proceduresofinterest', 'whatareyouinterestedin'],
  dateOfBirth: ['dob', 'dateofbirth', 'birthday', 'birthdate'],
  firstName: ['first', 'firstname'],
  lastName: ['last', 'lastname'],
  fullName: ['name', 'fullname'],
  gender: ['gender', 'sex'],
};

const valueMap = {
  gender: (gender) => {
    const newGender = String(gender).trim().toLowerCase().replace('female', 'f').replace('male', 'm').toUpperCase();
    return newGender;
  },
  dateOfBirth: (dob) => (dob ? cleanDate(dob) : dob),
};

const computedFieldMap = Object.entries(fieldMap).reduce((obj, [key, value]) => {
  (value || []).forEach((n) => {
    obj[n] = key;
  });
  return obj;
}, {});

const evalFormFields = (rawJSON) => {
  let formFields = {};
  try {
    formFields = JSON.parse(rawJSON);
  } catch (e) {}
  const entries = Object.entries(formFields || {})
    .map(([key, value]) => {
      const cleanKey = String(key)
        .replace(/[^a-zA-Z]/g, '')
        .toLowerCase();
      const camelKey = String(key)
        .replace(/_/g, ' ')
        .replace(/[^a-zA-Z\s]/g, '')
        .replace(/\s+/g, ' ')
        .split(' ')
        .map((n, idx) => (idx === 0 ? n.toLowerCase() : firstLetterToUppercase(n)))
        .join('');
      const finalKey = computedFieldMap[cleanKey] || camelKey;
      const finalValue = valueMap[finalKey] ? valueMap[finalKey](value) : value;
      return [finalKey, finalValue];
    })
    .reduce((obj, [key, value]) => {
      if (arrays.includes(key)) {
        obj[key] = obj[key] || [];
        obj[key].push(value);
        return obj;
      }
      obj[key] = value;
      return obj;
    }, {});

  return entries;
};

export default evalFormFields;
